var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ProjectsFeatured extends Component {
    constructor() {
        super('ProjectsFeatured', false);
        this.currentIndex = 0;
        this.projectLimit = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.module-projets-featured').length > 0) {
                $('.module-projets-featured .btn-prev').on('click', (event) => {
                    event.preventDefault();
                    this.prev();
                });
                $('.module-projets-featured .btn-next').on('click', (event) => {
                    event.preventDefault();
                    this.next();
                });
                $('.module-projets-featured--project.is-highlighted').on('click', (event) => {
                    window.location.href = $('.module-projets-featured .btn-view-all').attr('href');
                });
                $('.module-projets-featured--project:not(.is-highlighted)').on('click', (event) => {
                    this.goto($(event.currentTarget).index());
                });
                let touchStartX = 0;
                let touchEndX = 0;
                $('.module-projets-featured--track').on('touchstart', (event) => {
                    touchStartX = event.touches[0].clientX;
                });
                $('.module-projets-featured--track').on('touchend', (event) => {
                    touchEndX = event.changedTouches[0].clientX;
                    if (touchEndX < touchStartX)
                        this.next();
                    if (touchEndX > touchStartX)
                        this.prev();
                });
                $(window).on('resize', () => {
                    this.computeHeight();
                });
                this.computeHeight();
            }
            this.success();
        });
    }
    goto(index) {
        this.currentIndex = index;
        $('.module-projets-featured--project').removeClass('is-highlighted');
        $('.module-projets-featured--project').eq(this.currentIndex).addClass('is-highlighted');
    }
    next() {
        this.currentIndex++;
        if (this.currentIndex >= $('.module-projets-featured--project').length - this.projectLimit)
            this.currentIndex = $('.module-projets-featured--project').length - this.projectLimit - 1;
        //if (this.currentIndex >= $('.module-projets-featured--project').length - this.projectLimit) this.currentIndex = 0;
        console.log(this.currentIndex);
        this.goto(this.currentIndex);
    }
    prev() {
        this.currentIndex--;
        if (this.currentIndex < 0)
            this.currentIndex = 0;
        this.goto(this.currentIndex);
    }
    computeHeight() {
        if ($(window).width() < 1200)
            this.projectLimit = 1;
        if ($(window).width() < 768)
            this.projectLimit = 0;
        $('.module-projets-featured--track').css('height', $('.module-projets-featured--project.is-highlighted').height());
    }
}
